import { Component } from "react";
import * as React from "react";
import Header from "../../components/Header/Header";
import Menu from "../../components/Menu/Menu";
import PageContainer from "../../containers/PageContainer";
import { resolveRankByString } from "../../utils/Badges";
import { fetchDeadByDaylightProfile, fetchPlayerProfile, fetchPlayerProfileKarmaHistory } from "../../services/ApiContext";
import PlayerProfileInterface from "../../objects/PlayerProfileInterface";
import moment from 'moment';
import 'moment/locale/cs';
import TimeUtils from "../../utils/TimeUtils";
import MojangUtils from "../../utils/MojangUtils";
import { Link } from "react-router-dom";
import DeadByDaylight from "../../objects/DeadByDaylightInterface";
import ContentLoading from "../../components/Others/ContentLoading";
import { formatNumber } from "../../utils/NumberUtils";
import { VIPObject } from "./IVIPServerData";
import IKarmaStats from '../../objects/IKarmaStats';

interface PlayerLookupState {
	apiData: null | PlayerProfileInterface;
	dbdProfile: null | DeadByDaylight;
	isOriginal: boolean;
	isAtMember: boolean;
	karmaHistory: null | IKarmaStats[];
}

class PlayerLookup extends Component<any, PlayerLookupState> {

	constructor(props: any) {
		super(props);
		this.state = {
			apiData: null,
			dbdProfile: null,
			isOriginal: false,
			isAtMember: false,
			karmaHistory: null,
		};
	}

	public async componentDidMount() {
		const nick = this.props.match.params.nick;
		const apiData = await fetchPlayerProfile(nick);
		const dbdProfile = await fetchDeadByDaylightProfile(nick);

		// Check pokud je originala z externí API
		const isOriginal = await MojangUtils.checkOriginals(nick);
		const isAtMember = this.isAtMember(apiData.groups.vip.primary);
		let karmaHistory = null;
		if (isAtMember) {
			karmaHistory = await fetchPlayerProfileKarmaHistory(nick);
		}

		this.setState({
			apiData,
			dbdProfile,
			isOriginal,
			isAtMember,
			karmaHistory
		});
	}

	public resolveTime(time: number) {
		const lastOnline = moment(time);
		const nowTime = moment();
		const offlineMinutes = moment.duration(nowTime.diff(lastOnline)).asMinutes();
		const offlineHours = moment.duration(nowTime.diff(lastOnline)).asHours();
		const offlineDays = moment.duration(nowTime.diff(lastOnline)).asDays();
		const offlineYears = moment.duration(nowTime.diff(lastOnline)).asYears();
		if (offlineMinutes < 60) { // Minuty
			return " " + offlineMinutes.toFixed(0) + " minut(y)";
		} else if (offlineHours > 1 && offlineHours < 72) { // 1-3 den
			return " " + offlineHours.toFixed(0) + " hodin";
		} else if (offlineDays >= 1 && offlineDays < 365) {
			if (offlineDays === 1) {
				return " " + offlineDays.toFixed(0) + " dev";
			} else if (offlineDays === 2 || offlineDays === 4) {
				return " " + offlineDays.toFixed(0) + " dny";
			} else {
				return " " + offlineDays.toFixed(0) + " dní";
			}
		} else if (offlineYears >= 1) {
			return " " + offlineYears.toFixed(0) + " rok(ů)";
		} else {
			return "Velmi dlouho";
		}
	}

	public isAtMember(rank: string) {
		switch (rank) {
			case "owner":
			case "manager":
			case "developer":
			case "eventer":
			case "adminka":
			case "admin":
			case "builder":
			case "artist":
			case "helperka":
			case "helper":
			case "moderator":
			case "tester":
				return true;
			default:
				return false;
		}
	}

	public resolveGender(id: number) {
		if (id === 1) {
			return 	<div className="mr-2">
						<button disabled={true} type="button" className="gender-man"><i className="fa fa-mars fa-sm"/> Muž</button>
					</div>
					;
		}
		if (id === 2) {
			return <div className="mr-2">
				<button disabled={true} type="button" className="gender-woman"><i className="fa fa-venus fa-sm"/> Žena
				</button>
			</div>;
		}
		return null;
	}

	public resolveReputationBadge(value: number) {
		if (value >= 300) {
			return <button disabled={true} type="button" className="reputace-master">Reputace: {value}</button>;
		} else if (value >= 150) {
			return <button disabled={true} type="button" className="reputace-blue">Reputace: {value}</button>;
		} else if (value >= 50) {
			return <button disabled={true} type="button" className="reputace-green">Reputace: {value}</button>;
		} else if (value >= 20) {
			return <button disabled={true} type="button" className="reputace-yellow">Reputace: {value}</button>;
		} else if (value >= 0) {
			return <button disabled={true} type="button" className="reputace-basic">Reputace: {value}</button>;
		} else {
			return <button disabled={true} type="button" className="reputace-basic">Reputace: {value}</button>;
		}
	}

	public resolveKarmaHistoryTable(data: IKarmaStats[] | null) {
		let array: JSX.Element[] = [];
		if (data === null) {
			return array;
		}
		for (let karmaLog of data) {
			array.push(
				<tr key={karmaLog.id}>
					<td style={{width: "170px"}}>{moment(karmaLog.create_at).format("lll")}</td>
					<td style={{width: "120px"}}><Link to={"/player/" + karmaLog.reviewer_name}>{karmaLog.reviewer_name}</Link></td>
					<td style={{width: "170px"}}>{this.starsAsEmoji(karmaLog.stars)}</td>
					<td>{karmaLog.text}</td>
				</tr>
			);
		}
		if (array.length === 0) {
			array.push(
				<p className={"font-size-h5 pt-4 font-w500 text-center"}>Tohoto člena AT ještě nikdo nehodnotil.</p>
			);
		}
		return array;
	}

	public starsAsEmoji(stars: number) {
		switch (stars) {
			case 1:
				return "1 - ⭐";
			case 2:
				return "2 - ⭐⭐";
			case 3:
				return "3 - ⭐⭐⭐";
			case 4:
				return "4 - ⭐⭐⭐⭐";
			case 5:
				return "5 - ⭐⭐⭐⭐⭐";
			default:
				return "NIC :(";
		}
	}

	public resolveVIPStates(data: VIPObject) {
		let array: JSX.Element[] = [];
		if (data.vip.primary !== undefined) { // Permanení VIP jako první
			if (data.vip.primary === 'obsidian' || data.vip.primary === 'emerald' || data.vip.primary === 'diamond' || data.vip.primary === 'gold') {
				array.push(
					<tr key={data.vip.primary}>
						<td>{this.formatVipTitle(data.vip.primary)} (Global)</td>
						<td className="text-center">{data.vip.time !== 0 ? moment(data.vip.time).format("lll") : 'Permanentní'}</td>
					</tr>
				);
			}
		}
		if (data.vip.servers.survival !== undefined) {
			for (let vipType of data.vip.servers.survival) {
				array.push(
					<tr key={vipType.group}>
						<td>{this.formatVipTitle(vipType.group)} (Survival)</td>
						<td className="text-center">{vipType.time !== 0 ? moment(vipType.time).format("lll") : 'Permanentní'}</td>
					</tr>
				);
			}
		}
		if (data.vip.servers.skyblock !== undefined) {
			for (let vipType of data.vip.servers.skyblock) {
				array.push(
					<tr key={vipType.group}>
						<td>{this.formatVipTitle(vipType.group)} (Skyblock)</td>
						<td className="text-center">{vipType.time !== 0 ? moment(vipType.time).format("lll") : 'Permanentní'}</td>
					</tr>
				);
			}
		}
		if (data.vip.servers.creative !== undefined) {
			for (let vipType of data.vip.servers.creative) {
				array.push(
					<tr key={vipType.group}>
						<td>{this.formatVipTitle(vipType.group)} (Creative)</td>
						<td className="text-center">{vipType.time !== 0 ? moment(vipType.time).format("lll") : 'Permanentní'}</td>
					</tr>
				);
			}
		}
		if (data.vip.servers.prison !== undefined) {
			for (let vipType of data.vip.servers.prison) {
				array.push(
					<tr key={vipType.group}>
						<td>{this.formatVipTitle(vipType.group)} (Prison)</td>
						<td className="text-center">{vipType.time !== 0 ? moment(vipType.time).format("lll") : 'Permanentní'}</td>
					</tr>
				);
			}
		}
		if (data.vip.servers.vanilla !== undefined) {
			for (let vipType of data.vip.servers.vanilla) {
				array.push(
					<tr key={vipType.group}>
						<td>{this.formatVipTitle(vipType.group)} (Vanilla)</td>
						<td className="text-center">{vipType.time !== 0 ? moment(vipType.time).format("lll") : 'Permanentní'}</td>
					</tr>
				);
			}
		}
		if (array.length === 0) {
			array.push(
				<p className={"font-size-h5 pt-4 font-w500 text-center"}>Hráč nemá aktivní žádné VIP</p>
			);
		}
		return array;
	}

	public formatVipTitle(title: string) {
		if (title === 'obsidian') {
			return <span style={{color: '#8953ff', fontWeight: 800}}>Obsidian</span>;
		}
		if (title === 'emerald') {
			return <span style={{color: '#35c48c', fontWeight: 800}}>Emerald</span>;
		}
		if (title === 'diamond') {
			return <span style={{color: '#87cefa', fontWeight: 800}}>Diamond</span>;
		}
		if (title === 'gold') {
			return <span style={{color: '#d4a01d', fontWeight: 800}}>Gold</span>;
		}
	}

	public render() {
		if (this.state.apiData === null || this.state.dbdProfile === null) {
			return (
				<PageContainer>
					<Header/>
					<main id="main-container">
						<Menu/>
						<div className="content content-full">
							<div
								className="col-xl-12 col-md-12 col-sm-12 text-xl-center text-md-center text-sm-center pt-lg-9 pb-lg-10">
								<ContentLoading/>
							</div>
						</div>
					</main>
				</PageContainer>
			);
		}
		if (this.state.apiData.uuid === undefined) {
			return (
				<PageContainer>
					<Header/>
					<main id="main-container">
						<Menu/>
						<div className="content content-full">
							<div
								className="col-xl-12 col-md-12 col-sm-12 text-xl-center text-md-center text-sm-center pt-lg-9 pb-lg-10">
								<span><i className="fas fa-4x fa-exclamation font-size-h5 text-xplay-dark pb-3"/></span>
								<h4 className="font-size-h2"> Tento hráč se nenachází v naší databázi.</h4>
								<Link to="/">
									<button type="button" className="btn btn-primary">Zpět na hlavní stránku</button>
								</Link>
							</div>
						</div>
					</main>
				</PageContainer>
			);
		}
		return (
			<PageContainer>
				<Header/>
				<main id="main-container">
					<Menu/>

					{/* HEADER */}
					<div className="bg-body-light">
						<div className="content content-full">
							<div className="row my-3">
								<div className="col-md-8 d-md-flex align-items-md-center">
									<div className="py-4 py-md-0 text-center text-md-left" data-toggle="appear">
										<h1 className="font-size-h2 mb-2 ">{this.state.apiData.nick} (#{this.state.apiData.discriminator})</h1>
										<h2 className="font-size-lg font-w200 text-muted mb-0 d-inline-flex">
											{
												this.state.apiData.groups !== undefined && this.state.apiData.groups.vip !== null && this.state.apiData.groups.vip.primary !== null ?
													<div className="mr-2">{resolveRankByString(this.state.apiData.groups.vip.primary)}</div> :
														<div className="mr-2">{resolveRankByString("hrac")}</div>
											}
											{
												<div className="mr-2">
													{this.resolveReputationBadge(this.state.apiData.economy.karma_points)}
												</div>
											}
											{
												this.state.apiData.discord.id !== null ? <div className="mr-2">
													<button disabled={true} type="button" className="verified-badge"><i
														className="fa fa-check fa-sm"/> {this.state.apiData.gender === 1 ? "Ověřený" : this.state.apiData.gender === 2 ? "Ověřená" : "Ověřeno"}
													</button>
												</div> : <div className="flex-fill"/>
											}
											{
												this.state.apiData.gender !== 0 ? this.resolveGender(this.state.apiData.gender) :
													<div className="flex-fill"/>
											}
										</h2>
									</div>
								</div>
								<div className="col-md-4 d-md-flex align-items-md-center">
									<div className="row w-100 text-center">
										<div className="col-6 col-xl-6 offset-xl-6" data-toggle="appear" data-timeout="300">
											{
												this.state.apiData.is_online ?
													<div>
														<p className="font-size-h3 font-w600 text-body-color-dark mb-0">
															Online
														</p>
														<p className="font-size-sm font-w600 text-muted text-uppercase mb-0">
															{this.state.apiData.last_server}
														</p>
													</div> :
													<div>
														<p className="font-size-h3 font-w600 text-body-color-dark mb-0">
															Offline
														</p>
														<p className="font-size-sm font-w600 text-muted text-uppercase mb-0">
															{this.resolveTime(this.state.apiData.last_online)}
														</p>
													</div>
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="content content-full">
						<div className="row">
							{!this.state.apiData.social.status.includes("Tento hráč nemá nastavený status") ?
								<div className="col-xl-12">
									<div className="block block-rounded block-bordered">
										<div className="block-content border-dark border-4x">
											<p>{this.state.apiData.social.status}</p>
										</div>
									</div>
								</div> : null

							}
							<div className="col-xl-4">
								<div className="block block-rounded block-bordered">
									<div className="block-content bg-xwork">
										<p className="text-white text-uppercase text-xl-center font-size-sm font-w700">
											Aktuální skin
										</p>
									</div>
									<div className="block-content text-xl-center">
										<img
											className="profile-skin-height pb-3"
											alt="profile skin"
											src={"https://visage.surgeplay.com/full/512/" + this.state.apiData.uuid.replace("-", "")}
										/>
									</div>
								</div>
							</div>
							<div className="col-xl-8 js-appear-enabled" data-toggle="appear">
								<div className="block block-rounded text-center">
									<div className="block-content bg-xwork">
										<p className="text-white text-uppercase font-size-sm font-w700">
											Základní statistiky
										</p>
									</div>
									<div className="block-content block-content-full">
										<div className="row">
											<div className="col-4">
												<div className="font-size-h3 font-w500">
													{
														this.state.isOriginal ?
															<span><i
																className="far fa-2x fa-check-square h-50 text-xinspire"/></span>
															:
															<span><i
																className="far fa-2x fa-times-circle h-50 text-xplay-dark"/></span>
													}
												</div>
												<p className="text-muted mt-2 mb-0">
													Originální Minecraft
												</p>
											</div>
											<div className="col-4">
												<div className="font-size-h3 pt-3 font-w500">
													<span>{formatNumber(this.state.apiData.ranked.global_level)}</span>
												</div>
												<p className="text-muted mt-2 mb-0">
													Globální level
												</p>
											</div>
											<div className="col-4">
												<div className="font-size-h3 pt-3 font-w500">
													<span>{formatNumber(this.state.apiData.votes.total)}</span>
												</div>
												<p className="text-muted mt-2 mb-0">
													Celkem hlasů
												</p>
											</div>
										</div>
									</div>
								</div>
								<div className="block block-rounded text-center">
									<div className="block-content bg-xwork">
										<p className="text-white text-uppercase font-size-sm font-w700">
											Časové statistiky
										</p>
									</div>
									<div className="block-content block-content-full">
										<div className="row">
											<div className="col-4">
												<div className="font-size-h3 pt-3 font-w500">
													<span>{moment(this.state.apiData.registred).format("lll")}</span>
												</div>
												<p className="text-muted mt-2 mb-0">
													První připojení
												</p>
											</div>
											<div className="col-4">
												<div className="font-size-h3 pt-3 font-w500">
													<span>{TimeUtils.convertTime(this.state.apiData.played_time, true)}</span>
												</div>
												<p className="text-muted mt-2 mb-0">
													Celkem odehraný čas
												</p>
											</div>
											<div className="col-4">
												<div className="font-size-h3 pt-3 font-w500">
													<span>{moment(this.state.apiData.last_online).format("lll")}</span>
												</div>
												<p className="text-muted mt-2 mb-0">
													Naposledy viděn
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>

							{ /* Economy statistiky */}
							<div className="col-md-6 col-xl-6">
								<div className="block block-rounded">
									<div className="block-content block-content-full bg-xwork text-center">
										<p className="text-white text-uppercase font-size-sm font-w700 mt-2 mb-0">
											Economy stats
										</p>
									</div>
									<div className="block-content block-content-full">
										<table className="table table-borderless table-striped table-hover">
											<tbody>
											<tr>
												<td>
													<strong>CraftCoins</strong>
												</td>
												<td className="text-center" style={{width: "150px"}}>
													{formatNumber(this.state.apiData.economy.craft_coins)}
												</td>
											</tr>
											<tr>
												<td>
													<strong>CraftTokens</strong>
												</td>
												<td className="text-center">
													{formatNumber(this.state.apiData.economy.craft_tokens)}
												</td>
											</tr>
											<tr>
												<td>
													<strong>VoteTokens</strong>
												</td>
												<td className="text-center">
													{formatNumber(this.state.apiData.economy.vote_tokens)}
												</td>
											</tr>
											<tr>
												<td>
													<strong>Quest Points</strong>
												</td>
												<td className="text-center">
													{formatNumber(this.state.apiData.economy.quest_points)}
												</td>
											</tr>
											<tr>
												<td>
													<strong>Event Points</strong>
												</td>
												<td className="text-center">
													{formatNumber(this.state.apiData.economy.event_points)}
												</td>
											</tr>
											<tr>
												<td>
													<strong>Season Points</strong>
												</td>
												<td className="text-center">
													{formatNumber(this.state.apiData.economy.season_points)}
												</td>
											</tr>
											<tr>
												<td>
													<strong>Bug Points</strong>
												</td>
												<td className="text-center">
													{formatNumber(this.state.apiData.economy.bug_points)}
												</td>
											</tr>

											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div className="col-md-6 col-xl-6">
								<div className="block block-rounded">
									<div className="block-content block-content-full bg-xwork text-center">
										<p className="text-white text-uppercase font-size-sm font-w700 mt-2 mb-0">
											Server levels
										</p>
									</div>
									<div className="block-content block-content-full">
										<table className="table table-borderless table-striped table-hover">
											<tbody>
											<tr>
												<td>
													<strong>Survival</strong>
												</td>
												<td className="text-center" style={{width: "60px"}}>
													{this.state.apiData.ranked.survival_level}
												</td>
												<td className="text-center" style={{width: "140px"}}>
													({formatNumber(this.state.apiData.ranked.survival_experience)} XP)
												</td>
											</tr>
											<tr>
												<td>
													<strong>Skyblock</strong>
												</td>
												<td className="text-center" style={{width: "60px"}}>
													{this.state.apiData.ranked.skyblock_level}
												</td>
												<td className="text-center" style={{width: "140px"}}>
													({formatNumber(this.state.apiData.ranked.skyblock_experience)} XP)
												</td>
											</tr>
											<tr>
												<td>
													<strong>Creative</strong>
												</td>
												<td className="text-center" style={{width: "60px"}}>
													{this.state.apiData.ranked.creative_level}
												</td>
												<td className="text-center" style={{width: "140px"}}>
													({formatNumber(this.state.apiData.ranked.creative_experience)} XP)
												</td>
											</tr>
											<tr>
												<td>
													<strong>Vanilla: Lands</strong>
												</td>
												<td className="text-center" style={{width: "60px"}}>
													{this.state.apiData.ranked.vanilla_level}
												</td>
												<td className="text-center" style={{width: "140px"}}>
													({formatNumber(this.state.apiData.ranked.vanilla_experience)} XP)
												</td>
											</tr>
											<tr>
												<td>
													<strong>Staré servery</strong>
												</td>
												<td className="text-center" style={{width: "60px"}}>
													{this.state.apiData.ranked.old_servers_level}
												</td>
												<td className="text-center" style={{width: "140px"}}>
													({formatNumber(this.state.apiData.ranked.old_servers_experience)} XP)
												</td>
											</tr>

											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div className="col-md-6 col-xl-6">
								<div className="block block-rounded">
									<div className="block-content block-content-full bg-xwork text-center">
										<p className="text-white text-uppercase font-size-sm font-w700 mt-2 mb-0">
											Hlasování
										</p>
									</div>
									<div className="block-content block-content-full">
										<table className="table table-borderless table-striped table-hover">
											<tbody>
											<tr>
												<td>Celkem hlasů</td>
												<td className="text-center">{formatNumber(this.state.apiData.votes.total)}</td>
											</tr>
											<tr>
												<td>Měsíční hlasy (30 dní)</td>
												<td className="text-center">{formatNumber(this.state.apiData.votes.month)}</td>
											</tr>
											<tr>
												<td>Týdenní hlasy (7d)</td>
												<td className="text-center">{formatNumber(this.state.apiData.votes.week)}</td>
											</tr>
											<tr>
												<td>Poslední hlasování</td>
												<td className="text-center">{moment(this.state.apiData.votes.last_vote).format("lll")}</td>
											</tr>
											<tr>
												<td>VotePass Level</td>
												<td className="text-center">{formatNumber(this.state.apiData.votes.vote_pass)}</td>
											</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div className="col-md-6 col-xl-6">
								<div className="block block-rounded">
									<div className="block-content block-content-full bg-xwork text-center">
										<p className="text-white text-uppercase font-size-sm font-w700 mt-2 mb-0">
											Zakoupené VIP a jejich platnost
										</p>
									</div>
									<div className="block-content block-content-full">
										<table className="table table-borderless table-striped table-hover">
											<tbody>
											{this.resolveVIPStates(this.state.apiData.groups as VIPObject)}
											</tbody>
										</table>
									</div>
								</div>
							</div>

							{ this.state.karmaHistory !== null ? 
								<div className="col-md-12 col-xl-12">
								<div className="block block-rounded">
									<div className="block-content block-content-full bg-xwork text-center">
										<p className="text-white text-uppercase font-size-sm font-w700 mt-2 mb-0">
											Reputace - Historie hodnocení
										</p>
									</div>
									<div className="block-content block-content-full">
										<table className="table table-borderless table-striped table-hover" style={{tableLayout: "fixed"}}>
											<tbody>
												{this.resolveKarmaHistoryTable(this.state.karmaHistory)}
											</tbody>
										</table>
									</div>
								</div>
								</div> : null
							}

							<div className="col-md-12 col-xl-12">
								<div className="block block-rounded">
									<div className="block-content block-content-full bg-xwork-op text-center">
										<p className="text-white text-uppercase font-size-sm font-w700 mt-2 mb-0">
											Minigames
										</p>
									</div>
								</div>
							</div>
							<div className="col-md-6 col-xl-6">
								<div className="block block-rounded">
									<div className="block-content block-content-full bg-gd-sun text-center">
										<p className="text-white text-uppercase font-size-sm font-w700 mt-2 mb-0">
											Dead By Daylight
										</p>
									</div>
									<div className="block-content block-content-full">
										<table className="table table-borderless table-striped table-hover">
											{(this.state.dbdProfile.games_played !== undefined || this.state.dbdProfile.games_played === 0) ?
												<tbody>
												<tr>
													<td>
														<strong>Killer: Výhry</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.killer_wins}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Killer: Zabití</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.killer_kills}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Killer: Smrtelné zásahy</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.killer_downs}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Killer: Údery</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.killer_hits}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Survivor: Výhry</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.survivor_wins}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Survivor: Opraveno generátorů</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.survivor_generators_powered}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Survivor: Naplnění generátorů</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.survivor_fuels_filled}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Survivor: Hráčů oživeno</strong>
													</td>
													<td className="text-center" style={{width: "60px"}}>
														{this.state.dbdProfile.survivor_players_revived}
													</td>
												</tr>
												<tr>
													<td>
														<strong>Odehraný čas</strong>
													</td>
													<td className="text-center" style={{width: "150px"}}>
														{TimeUtils.convertTime((this.state.dbdProfile.playtime / 1000) / 60, true)}
													</td>
												</tr>
												</tbody> :
												<p className="font-size-h4 pt-3 font-w500 text-center">Hráč minihru
													nehrál.</p>
											}
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
			</PageContainer>
		);
	}
}

export default PlayerLookup;
